<template>
  <div v-drag
       >
    <a-modal v-model:visible="dialogVisible"
             :maskClosable="false"
              :bodyStyle="bodyStyle"
            :footer="null"
            :closable="false"
          
 wrapClassName="my-modal-wrap"
              >
    <a-form :labelCol="{span:10}"
    :colon="false"
      :model="questionForm"
              :wrapperCol="{span:8}">
               <a-form-item label="请选择考点"> 
               <a-select v-model:value="questionForm.knowledgeId"
                placeholder="请选择"
                size="large"
                style="width: 100%;"
                 >
        <a-select-option v-for="item in list"
                         :key="item.knowledge_id"
                         :value="item.knowledge_id">
          {{item.knowledge_desc}}
        </a-select-option>
      </a-select>  
         </a-form-item>
        <a-form-item label="请选择题目数量"> 
            <a-input-number v-model:value="questionForm.question_num"
                           :min="1"
                           style="width: 100%;"
                           :max="10"
                              label=""></a-input-number>
        </a-form-item>
      
        
      </a-form>
   <div class="btn_warp">
        <div @click="handleClose">
          取消
        </div>
        <div @click="save">
          确认
        </div>
      </div>
    </a-modal>
    
  </div>
</template>


<script setup>
import { getKnowledgeByParentid } from '@/api/knowledge.js'
import { InputSearch, message } from 'ant-design-vue';
import { useRouter } from 'vue-router'
import { ref, watch,reactive} from 'vue'
let router = useRouter()
let dialogVisible = ref(false)
let list = ref([])
let questionForm = reactive({
  question_num:5,
  knowledgeId:""
})
let lecture_id = ref('')
let subjectId = ref('')
let knowledgeId = ref('')
const bodyStyle = {
        // 先清空四边
         paddingTop: "64px",  
  paddingBottom: 0,  
  paddingLeft:0,   
    paddingRight:0  
}
const value = ref('')
const keywords = ref('')
const handleClose = () => {
  knowledgeId.value = ""
  dialogVisible.value = false
  lecture_id.value = ""
}
const toDetail = (item) => {
  router.push('/course/preview?type=video&url=' + item.url + "&knowledge_desc=" + item.knowledge_desc)
  dialogVisible.value = false
}
// const change = (index, bool) => {
//   this.$forceUpdate()
// }
let getKnowledgeList = async () => {
  let params = {
    knowledge_id: subjectId.value,
  }
  const { data } = await getKnowledgeByParentid(params)
  list.value = data.list
}
const save = (item) => {
 if(questionForm.knowledgeId == ''){
    message.error('请选择考点')
    return
  }
   if(questionForm.question_num == ''){
    message.error('请选择题目数量')
    return
  }
  console.log('questionForm',questionForm)
  let form = {
    question_num: questionForm.question_num,
    knowledge_id: questionForm.knowledgeId,
     lecture_id:lecture_id.value
  }
  window.sessionStorage.removeItem('testpaperCardIndex')
  window.sessionStorage.removeItem('paper')
  router.push('/doPaper?isKnowledge=1&form=' + JSON.stringify(form))
}
watch(keywords, (newValue, oldValue) => {
   
});

 
defineExpose({
  getKnowledgeList, dialogVisible, subjectId,list,lecture_id
})


</script>

<style lang="scss" >
.my-modal-wrap {
.center_table {
  min-width: 300px;
}
.btn_warp {
  height: 70rem;
  border-top: 1px solid #e5e5e5;
  display: flex;
  // position: absolute;
  bottom: 0;
  width: 100%;
  div {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    &:nth-child(1) {
      font-size: 24rem;
      font-weight: 400;
      color: #999999;
      border-right: 1px solid #e5e5e5;
    }
    &:nth-child(2) {
      font-size: 24rem;
     font-weight: 400;
      color: #2196f3;
    }
  }
}
.table_head {
  // height: 70rem;
  padding: 20rem 0;
  background: #f6f6f6;
  display: flex;
  align-items: center;
  div {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 24rem;

    color: #666660;
    &:nth-child(1) {
      flex: 3;
      text-indent: 60rem;
    }
    &:nth-child(2) {
      flex: 1;
      text-indent: 103rem;
    }
  }
}
.table_line {
  background: white;
  border-bottom: 1px solid #eaeaea;
  padding: 20rem 0;
  .two {
    display: flex;
    align-items: center;
    margin: 5px 0;
    position: relative;
    div {
      &:nth-child(1) {
        flex: 3;
        text-indent: 60rem;
        padding-right: 70rem;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      &:nth-child(2) {
        flex: 1;
        text-indent: 33rem;
      }
    }
  }
}

 

// 搜索框
.container {
  position: relative;
  .icon {
    position: absolute;
    width: 24px;
    height: 24px;
    right: 30%; /* 距离右侧的距离 */
    top: 48%; /* 垂直居中 */
    transform: translateY(-50%); /* 沿垂直方向上偏移图标的一半高度 */
    z-index: 9999; /* 图标在上层 */
  }
  .icon img {
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
}
.top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .top_title {
    flex: 1;
    font-size: 24rem;
    margin-left: 100rem;
  }

  .search {
    width: 200px;
    height: 35px;
    margin-right: 60rem;
    border-radius: 18px;
    outline: none;
    border: 1px solid #ccc;
    background-color: #1890ff;
    padding-left: 20px;
    padding-right: 50px;
    font-size: 14px;
    caret-color: #fff;
    color: #fff;
  }
  :deep .search::placeholder {
    color: #fff;
  }
}
 .ant-modal{
top: 35%;
width: 644rem !important;
}
  .ant-modal-content {
  border-radius: 32px;
 
}
.ant-form-item-label{
  margin-right:88rem
}
.ant-form-item-label > label{
  font-size: 28rem;
  font-weight: 600;
}
.ant-form-item{
  margin-bottom: 40rem;
}
.ant-input-number{
   font-size: 24rem
}
.ant-select-selection-item{
  font-size: 24rem
}
}
</style>